var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgLoginEmail = ({
  title,
  titleId,
  ...props
}, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  preserveAspectRatio: "none",
  overflow: "visible",
  style: {
    display: "block"
  },
  width: 16,
  height: 16,
  viewBox: "0 0 16 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  ref: ref,
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
  id: "Frame"
}, /*#__PURE__*/React.createElement("path", {
  id: "Vector",
  d: "M4.66797 5.66699L6.62932 6.82659C7.77277 7.50266 8.22983 7.50266 9.3733 6.82659L11.3346 5.66699",
  stroke: "#A69782",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  id: "Vector_2",
  d: "M1.34254 8.98341C1.38612 11.0271 1.40792 12.0489 2.162 12.8059C2.91608 13.5629 3.96558 13.5892 6.06458 13.6419C7.35823 13.6745 8.63916 13.6745 9.93283 13.6419C12.0318 13.5892 13.0813 13.5629 13.8354 12.8059C14.5895 12.0489 14.6113 11.0271 14.6548 8.98341C14.6689 8.32628 14.6689 7.67308 14.6548 7.01594C14.6113 4.97225 14.5895 3.9504 13.8354 3.19345C13.0813 2.4365 12.0318 2.41013 9.93283 2.35739C8.63916 2.32488 7.35823 2.32488 6.06458 2.35738C3.96558 2.41012 2.91608 2.43648 2.162 3.19344C1.40791 3.9504 1.38612 4.97224 1.34254 7.01594C1.32852 7.67308 1.32853 8.32628 1.34254 8.98341Z",
  stroke: "#A69782",
  strokeLinejoin: "round"
}))));
const ForwardRef = /*#__PURE__*/forwardRef(SvgLoginEmail);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/login-email.c7806b01de65d2207df4eafc815b7ac0.svg";